import { STATUSPAGE, TreeMapWidget } from '@repo/ui';

export interface TreeMapDataItem {
  x: string;
  y: number;
}
[];

interface IResponseActivityListingInProgress {
  data: TreeMapDataItem[];
  height?: number;
  loading: STATUSPAGE;
  title: string;
}

export const ChartOngoingActivityByInstitution = ({
  data,
  loading,
  title,
  height,
}: IResponseActivityListingInProgress) => {
  return (
    <TreeMapWidget
      title={title}
      height={height}
      loading={loading}
      data={[{ data }]}
    />
  );
};
